/* Customer Reviews aggregation — interactivity
 * Loaded globally (layout/theme.liquid) so it survives PJAX page swaps.
 * All clicks are delegated on document, so it works for content injected by PJAX too.
 */
(function () {
  'use strict';
  var PRODUCTS = {};
  var navObserver = null;

  function loadData() {
    var el = document.getElementById('cr-data');
    if (el) {
      try {
        var d = JSON.parse(el.textContent || '{}');
        PRODUCTS = (d && d.products) || {};
      } catch (e) { console.error('CR data parse', e); }
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function shortTitle(t) {
    return String(t || '').replace(/^TAITIY\s+/i, '').replace(/^Taitiy\s+/i, '').slice(0, 34);
  }

  function stars(n) {
    n = Math.round(Number(n) || 0);
    var s = '';
    for (var i = 1; i <= 5; i++) {
      if (i <= n) s += '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.4 7.2h7.6l-6 4.8 2.4 7.2-6-4.8-6 4.8 2.4-7.2-6-4.8h7.6z"/></svg>';
      else s += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2l2.4 7.2h7.6l-6 4.8 2.4 7.2-6-4.8-6 4.8 2.4-7.2-6-4.8h7.6z"/></svg>';
    }
    return s;
  }

  function reviewCard(r) {
    if (!r) return '';
    var initials = (r.author || 'C').trim().charAt(0).toUpperCase();
    var verified = r.verified ? '<span class="cr-card__verified"><svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>Verified Customer</span>' : '';
    return '<article class="cr-card">' +
      '<div class="cr-card__top"><span class="cr-card__avatar">' + initials + '</span><div>' +
      '<div class="cr-card__author">' + escapeHtml(r.author || 'Customer') + '</div>' + verified + '</div></div>' +
      '<div class="cr-card__stars">' + stars(r.rating) + '</div>' +
      (r.title ? '<h4 class="cr-card__title">' + escapeHtml(r.title) + '</h4>' : '') +
      (r.body ? '<p class="cr-card__body">' + escapeHtml(r.body) + '</p>' : '') +
      '<div class="cr-card__foot">' +
        (r.date ? '<span class="cr-card__date">' + escapeHtml(r.date) + '</span>' : '<span></span>') +
        '<button type="button" class="cr-card__like" data-like aria-pressed="false"><svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.3l.9-4.3a1.6 1.6 0 0 0-.5-1.2L14.2 1 8.6 7.6A2 2 0 0 0 7.6 9v11a2 2 0 0 0 2 2h9a2 2 0 0 0 2-1.4l1.9-7A2 2 0 0 0 23 10z"/></svg><span data-like-count>Helpful</span></button>' +
      '</div></article>';
  }

  /* ---- Hero stats ---- */
  function setStat(k, v) {
    var n = document.querySelector('[data-cr-stat="' + k + '"]');
    if (n) n.textContent = v;
  }
  function fillStats() {
    var handles = Object.keys(PRODUCTS);
    var totalReviews = 0, sum = 0, cnt = 0;
    handles.forEach(function (h) {
      var p = PRODUCTS[h];
      totalReviews += Number(p.count) || 0;
      if (p.avg && p.count) { sum += p.avg * p.count; cnt += p.count; }
    });
    var vids = document.querySelectorAll('[data-cr-videos] .cr-media').length;
    var phos = document.querySelectorAll('[data-cr-photos] .cr-media').length;
    var avg = cnt ? (sum / cnt) : 0;
    setStat('avg', avg ? avg.toFixed(1) + ' ★' : '–');
    setStat('reviews', totalReviews.toLocaleString());
    setStat('products', handles.length);
    setStat('media', (vids + phos).toLocaleString());
  }

  /* ---- Sticky product nav ---- */
  function buildNav() {
    var nav = document.querySelector('[data-cr-nav]');
    if (!nav) return;
    if (!Object.keys(PRODUCTS).length) return;
    var html = '';
    Object.keys(PRODUCTS).forEach(function (h) {
      var p = PRODUCTS[h];
      var img = p.image ? '<img src="' + p.image + '" alt="">' : '';
      html += '<button type="button" class="cr-nav__chip" data-goto="' + h + '">' + img + '<span>' + escapeHtml(shortTitle(p.title)) + '</span></button>';
    });
    nav.innerHTML = html;
    if (navObserver) { try { navObserver.disconnect(); } catch (e) {} }
    var sections = Object.keys(PRODUCTS).map(function (h) { return document.getElementById('cr-prod-' + h); }).filter(Boolean);
    if ('IntersectionObserver' in window && sections.length) {
      navObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            var id = en.target.getAttribute('data-cr-prod');
            nav.querySelectorAll('.cr-nav__chip').forEach(function (c) {
              c.classList.toggle('is-active', c.getAttribute('data-goto') === id);
            });
          }
        });
      }, { rootMargin: '-80px 0px -70% 0px' });
      sections.forEach(function (s) { navObserver.observe(s); });
    }
  }

  function scrollToProduct(h) {
    var sec = document.getElementById('cr-prod-' + h);
    if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ---- Show more (media columns) ---- */
  function setupShowMore() {
    document.querySelectorAll('.cr-section').forEach(function (sec) {
      var grid = sec.querySelector('[data-cr-videos], [data-cr-photos]');
      var btn = sec.querySelector('[data-cr-showmore]');
      if (!grid || !btn || btn.dataset.done) return;
      var tiles = grid.querySelectorAll('.cr-media');
      var limit = grid.classList.contains('cr-photos') ? 30 : 16;
      if (tiles.length > limit) {
        for (var i = limit; i < tiles.length; i++) tiles[i].style.display = 'none';
        btn.hidden = false;
        btn.addEventListener('click', function () {
          for (var j = limit; j < tiles.length; j++) tiles[j].style.display = '';
          btn.hidden = true;
        });
        btn.dataset.done = '1';
      }
    });
  }

  /* ---- Modal ---- */
  var modal = null;
  function getModal() { return modal || (modal = document.getElementById('crModal')); }

  function openModal(el) {
    var m = getModal();
    if (!m) return;
    var handle = el.getAttribute('data-ph');
    var p = PRODUCTS[handle];
    if (!p) return;
    var mediaBox = m.querySelector('[data-cr-modal-media]');
    mediaBox.innerHTML = '';
    if (el.hasAttribute('data-vsrc')) {
      var vid = document.createElement('video');
      vid.controls = true;
      vid.playsInline = true;
      vid.setAttribute('playsinline', '');
      vid.setAttribute('webkit-playsinline', '');
      vid.poster = el.getAttribute('data-vposter') || '';
      var src = document.createElement('source');
      src.src = el.getAttribute('data-vsrc');
      src.type = 'video/mp4';
      vid.appendChild(src);
      mediaBox.appendChild(vid);
      // We are inside a user click handler, so this counts as a user gesture -> playback is allowed.
      var pr = vid.play();
      if (pr && pr.catch) pr.catch(function () {});
    } else {
      var img = document.createElement('img');
      img.src = el.getAttribute('data-full');
      img.alt = 'Customer photo';
      mediaBox.appendChild(img);
    }
    var link = m.querySelector('[data-cr-prod-link]');
    link.textContent = 'View ' + shortTitle(p.title);
    link.href = p.url;
    m.querySelector('[data-cr-prod-stars]').innerHTML = stars(p.avg) +
      ' <span style="color:#3a352e;font-weight:700;margin-left:6px">' + (p.avg || '') + '</span>';
    m.querySelector('[data-cr-prod-title]').textContent = p.title;
    var revBox = m.querySelector('[data-cr-modal-reviews]');
    revBox.innerHTML = (p.reviews && p.reviews.length)
      ? p.reviews.map(reviewCard).join('')
      : '<p style="color:#8a8275">No written review for this item yet.</p>';
    m.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    var m = getModal();
    if (!m || m.hidden) return;
    m.hidden = true;
    var v = m.querySelector('video');
    if (v) { try { v.pause(); } catch (e) {} }
    document.body.style.overflow = '';
  }

  function toggleLike(b) {
    var pressed = b.getAttribute('aria-pressed') === 'true';
    b.setAttribute('aria-pressed', pressed ? 'false' : 'true');
    var lbl = b.querySelector('[data-like-count]');
    if (lbl) lbl.textContent = pressed ? 'Helpful' : 'Thanks!';
  }

  function showMore(btn) {
    var sec = btn.closest('.cr-section');
    if (!sec) return;
    var grid = sec.querySelector('[data-cr-videos], [data-cr-photos]');
    if (!grid) return;
    var tiles = grid.querySelectorAll('.cr-media');
    tiles.forEach(function (t) { t.style.display = ''; });
    btn.hidden = true;
  }

  /* ---- Delegated click handling (survives PJAX) ---- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) t = t && t.parentNode;
    if (!t || !t.closest) return;
    var media = t.closest('.cr-media');
    if (media) { e.preventDefault(); openModal(media); return; }
    var close = t.closest('[data-cr-close]');
    if (close) { closeModal(); return; }
    var like = t.closest('[data-like]');
    if (like) { toggleLike(like); return; }
    var goto = t.closest('[data-goto]');
    if (goto) { scrollToProduct(goto.getAttribute('data-goto')); return; }
    var sm = t.closest('[data-cr-showmore]');
    if (sm) { showMore(sm); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  /* ---- Init + re-init on PJAX / section load ---- */
  function init() {
    loadData();
    fillStats();
    buildNav();
    setupShowMore();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-run when this section is (re)loaded — covers PJAX page swaps.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#cr-data')) init();
  });
  document.addEventListener('pjax:end', function () { init(); });
  document.addEventListener('pjax:success', function () { init(); });
})();
